import request from '@/utils/request'
// 获取周报
export function getGNSSLastByMcuID(params) {
  return request({
    // url: '/v3/gps/getGNSSByMcuID',
    url: '/v3/location/getGNSSLastByMcuID',
    // url: '/v2/device/getDetailByMcuId',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
    // responseType: 'arraybuffer'
  })
}
export function updateGnssConfig(params) {
  return request({
    url: '/v3/location/updateGnssConfig',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params

  })
}
export function getGnssConfig(params) {
  return request({
    url: '/v3/location/getGnssConfig',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params

  })
}
export function reportDetail(params) { // 周报--设备基本信息
  return request({
    url: 'v3/report/findDeviceInfo',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
  })
}
export function listWarningPushMsg(params) { // 周报--警告信息
  return request({
    url: 'v3/report/listWarningPushMsg',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
  })
}
// 警告数据列表
export function listWarningPushMsg2(params) {
  return request({
    url: 'v3/report/listWarningPushMsg2',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
  })
}
export function getOdc(params) { // 周报--警告信息
  return request({
    url: 'v3/report/getOdcByDay',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
  })
}
// 表格中柱状图数据
export function getHourReport(params) {
  return request({
    url: '/v3/report/getHourReport',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
  })
}
export function listChargingDischarging(params) { // 周报--警告信息
  return request({
    url: 'v3/report/chargingDischarging/listChargingDischarging',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
  })
}

export function getConfigByMcuId(params) { // 获取Config信息
  return request({
    url: 'v3/manager/configData/getLastOne',
    method: 'post',
    headers: { 'token': 'nmamtf' },
    data: params
  })
}

